module.exports = __webpack_public_path__ + "img/display-capture-midi-screenshot-phone-frame-with-shadow.38d2b452.png";